<template>

  <div>

    <loading-indicator :loading="isLoading"></loading-indicator>

    <template v-if="!isLoading">

  		<div class="columns orderHistory" v-if="orderHistory.length > 0">

  			<div class="column is-4">

  				<data-table :data="orderHistory" bordered="bordered" striped="striped">

  					<column label="Name" field="catalogName"></column>
  					<column label="Stück" field="totalQuantity"></column>
  					<column label="Paket" field="customization"></column>

  					<column label="Rücklaufquote" field="couponRedemptionRate"></column>
  					<column label="DB" field="turnover"></column>
  					<column label="Umsatz" field="grossMargin"></column>

  				</data-table>

  			</div>

  			<div class="column is-7">

  				<vue-chart type="bar" :height="100" :data="chart1Data"></vue-chart>
  				<vue-chart type="bar" :height="100" :data="chart2Data"></vue-chart>

  			</div>

  		</div>

  		<div v-else class="notice">
  			<alert type="info" :closable="false">
		  		Für diese Apotheke liegen keine Bestellungen vor.
  			</alert>
  		</div>

    </template>

  </div>

</template>


<script>
import VueChart from 'vue-chart-js';
export default {

	name: 'site',

	components: {
		VueChart
  },

  props: {
    siteId: {
      type: Number,
      default: null
    }
  },

  data() {

		return {
			siteID: null,
			siteCatalog: null,
			orderHistory: [],
			isLoading: true,
			chart1Data: {
				labels: [],
		        datasets: [
	          {
              label: 'Auflage',
              backgroundColor: '#9CB5B6',
              data: [],
              borderWidth: 1
		        },
	          {
              label: 'Rücklauf',
              backgroundColor: '#FF70A9',
              data: [],
              borderWidth: 1
		        }
				]
	    },
			chart2Data: {
				labels: [],
        datasets: [
					{
						label: 'DB',
						backgroundColor: '#FFB060',
						data: [],
						borderWidth: 1
	        },
					{
						label: 'Umsatz',
						backgroundColor: '#4DB1F8',
						data: [],
						borderWidth: 1
					},
				]
	    },

		}
	},

  created() {
    this.fetchData();
  },

  methods: {


    fetchData() {

      this.isLoading = true;

      this.axios.get(this.$config.api + 'site/' + this.siteId + '/orderHistory?orderBy=catalogName%20ASC')
      .then((response) => {
        response.data.site.forEach(data => {

          // first chart
          this.chart1Data.labels.push(data.catalogName);
          this.chart1Data.datasets[0].data.push(data.totalQuantity);
          this.chart1Data.datasets[1].data.push(data.redeemedCouponsQty);

          // second chart
          this.chart2Data.labels.push(data.catalogName);
          this.chart2Data.datasets[0].data.push(data.turnover);
          this.chart2Data.datasets[1].data.push(data.grossMargin);

          // table data
          if(data.totalQuantity > 0 || data.grossMargin > 0 || data.turnover != null || data.redeemedCouponsQty > 0 ||  data.couponRedemptionRate > 0) {
            this.orderHistory.push(data);
          }

          if(data.redeemedCouponsQty > 0 && (data.couponRedemptionRate == 0 || data.couponRedemptionRate == null)) {
            data.couponRedemptionRate = data.redeemedCouponsQty + ' (' + parseFloat(data.couponRedemptionRate).toFixed(2).toString().replace(/[.]/, ",") + '%)';
          } else if(data.couponRedemptionRate > 0) {
            data.couponRedemptionRate = data.redeemedCouponsQty + ' (' + parseFloat(data.couponRedemptionRate).toFixed(2).toString().replace(/[.]/, ",") + '%)';
          } else {
            data.couponsRedemptionRate = "";
          }

          data.grossMargin = data.grossMargin != null && data.grossMargin > 0
            ? '€ ' + parseFloat(data.grossMargin).toFixed(2).toString().replace(/[.]/, ",")
            : '';

          data.turnover = data.turnover != null
            ? '€ ' + parseFloat(data.turnover).toFixed(2).toString().replace(/[.]/, ",")
            : '';


        });


        // reverse the array
        this.orderHistory.reverse();
        this.isLoading = false;

      }).catch((error) => {
        console.log("error: ", error);

      });

      // site.nightDutySites&fields=site,nightDutySites,nightDutySite,name,id,extRef,zipcode,apothekerkammerId
    }


  }
}
</script>


<style lang="scss" scoped>

	.orderHistory {
		justify-content: space-between;
	}
	.orderHistory canvas {
		margin-bottom: 25px;
	}


  	@media screen and (max-width: 1600px) {

  		.orderHistory {
  			flex-wrap: wrap;
  		}
  		.orderHistory .column:first-child {
  			order: 2;
  			width: 100% !important;
  			padding: 0;
  		}
  		.orderHistory .column:nth-child(2) {
  			order: 1;
  			width: 100% !important;
  			padding: 0;
  		}

  	}

</style>
